
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/2nd-snapshot-reveal",
      function () {
        return require("private-next-pages/2nd-snapshot-reveal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/2nd-snapshot-reveal"])
      });
    }
  